import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export type InitializeEditElementType = 'text' | 'photo' | 'sticker' | 'message';

export type GetInitializeEditOptions = {
  elementPosition: string;
  elementType: InitializeEditElementType;
} & DefaultProductOptions;

export function getInitializeEditTag(options: GetInitializeEditOptions) {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const initializeEditModal = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    {
      eventInfo: {
        eventName: options.elementType,
        eventAction: 'start',
      },
    },
  ];

  const { modal, user } = getModalTag(options.productType, 'Edit Mode', initializeEditModal, options.projectID);

  return { modal, product, user };
}
